import { getStressAssessmentRole } from '@fukuri-admins/utils/common/cookies';
import { Navigate } from 'react-router-dom';
import { ClientSideMenu } from '~/features/ClientSideMenu';
import { StressAssessmentRoleSelect } from '~/features/StressAssessmentRoleSelect';
import { ROUTES } from '~/utils/routes';
import styles from './styles.module.scss';

export const Screen: React.FC = () => {
  const stressAssessmentRole = getStressAssessmentRole();

  if (stressAssessmentRole) {
    return <Navigate to={ROUTES.STRESS_ASSESSMENTS.INDEX} />;
  }

  return (
    <div className={styles.Screen}>
      <ClientSideMenu />
      <StressAssessmentRoleSelect />
    </div>
  );
};
